module.exports = __webpack_public_path__ + "img/home_funeng_bg_number@3x.7eec245c.png";